import React, { useMemo, useState } from "react";
import { Box, Divider, List, ListItemButton, ListItemText, Menu, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFiltersRegistry } from "../../../../../context/FiltersProvider";
import { getMenuSavedFilters } from "../../../../../context/FiltersProvider/selectors/menuSelectors";
import { FilterDefinition } from "../../../../../context/FiltersProvider/types";
import { FilterContexType } from "../../../../layout/ViewHeader";

type Props = {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
	onSelect: (filter: FilterDefinition) => void;
	filterContext?: FilterContexType;
};

const SavedFiltersMenu: React.FC<Props> = ({ anchorEl, open, onClose, onSelect, filterContext }) => {
	const { t } = useTranslation("common");
	const { registry } = useFiltersRegistry();

	const [search, setSearch] = useState("");

	const filters = useMemo(() => {
		return getMenuSavedFilters(registry, {
			visibility: filterContext,
			search,
		});
	}, [registry, search]);

	return (
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					width: "280px",
					maxHeight: "340px",
					overflowY: "auto",
				},
			}}
		>
			<Box
				sx={{
					p: 1.5,
					position: "sticky",
					top: 0,
					backgroundColor: "background.paper",
					zIndex: 1,
				}}
			>
				<TextField
					size="small"
					fullWidth
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					placeholder={t("search")}
				/>
			</Box>

			<Divider />

			<Box
				sx={{
					maxHeight: 320,
					overflowY: "auto",
				}}
			>
				<List dense disablePadding>
					{filters.length > 0 ? (
						filters.map((filter) => (
							<ListItemButton
								key={filter.id}
								onClick={() => {
									onSelect(filter);
									onClose();
								}}
							>
								<ListItemText>
									<Typography variant="body1">{filter.name}</Typography>
								</ListItemText>
							</ListItemButton>
						))
					) : (
						<Typography px={2} py={1} variant="body2">
							{t("no filters")}
						</Typography>
					)}
				</List>
			</Box>
		</Menu>
	);
};

export default SavedFiltersMenu;
